import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Col,
} from "reactstrap";

import routes from "routes.js";
import "../../assets/scss/react/_buttons.scss";

function Header(props) {
    const [isOpen, setIsOpen] = useState(false);
    const [color, setColor] = useState("transparent");
    const [toggleServer, setToggleServer] = useState(false);
    const [maintainModal, setMainTainModal] = useState(false);
    const [show, setShow] = useState(false);
    const sidebarToggle = React.useRef();
    const location = useLocation();

    const toggleConfirm = () => setMainTainModal(!maintainModal);
    
    const handleClose = (e) => {
		e.preventDefault();
		        setShow(false);
    };

    const handleOpen = (e) => {
		e.preventDefault();
        setShow(true);
    };

    const runServerMode = (e) => {
        const server = e.target?.checked;
        setToggleServer(server);

        fetch(`${process.env.REACT_APP_BACKEND_URL}private/auth/maintenance-mode/${server}`, {
            method: 'GET',
        })
        .then(response => response.json())
        .then(data => {
            if (data.Status === "MaintenanceOn") {
                toggleConfirm();
            } else {
                setMainTainModal(false);
            }
        })
        .catch(error => {
            // Handle error
        });
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}private/auth/get-maintenance-mode`, {
            method: 'GET',
        })
        .then(response => response.json())
        .then(data => {
            setToggleServer(data?.Status);
        });
    }, [toggleServer]);

    const handleMaintainModalOff = () => {
        setMainTainModal(false);
    };

    useEffect(() => {
        let timeoutId;

        function onUserActivity() {
            if (timeoutId) clearTimeout(timeoutId);

            timeoutId = setTimeout(() => {
                sessionStorage.removeItem('accessToken');
                window.location.href = '/auth/logout';
            }, 1800000);
        }

        window.addEventListener('mousemove', onUserActivity);
        window.addEventListener('keydown', onUserActivity);

        return () => {
            window.removeEventListener('mousemove', onUserActivity);
            window.removeEventListener('keydown', onUserActivity);
        };
    }, []);

    const toggle = () => {
        setColor(isOpen ? "transparent" : "dark");
        setIsOpen(!isOpen);
    };

    const getBrand = () => {
        let brandName = props.title ? props.title : "Default Brand";
        routes.map((prop) => {
            if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
                brandName = prop.name;
            }
            return null;
        });
        return brandName;
    };

    const openSidebar = () => {
        document.documentElement.classList.toggle("nav-open");
        sidebarToggle.current.classList.toggle("toggled");
    };

    const updateColor = () => {
        if (window.innerWidth < 993 && isOpen) {
            setColor("dark");
        } else {
            setColor("transparent");
        }
    };

    useEffect(() => {
        window.addEventListener("resize", updateColor.bind(this));
    }, []);

    useEffect(() => {
        if (window.innerWidth < 993 && document.documentElement.className.indexOf("nav-open") !== -1) {
            document.documentElement.classList.toggle("nav-open");
            sidebarToggle.current.classList.toggle("toggled");
        }
    }, [location]);

    const logout = () => {
        sessionStorage.removeItem("accessToken");
        window.location.href = "purchaser-auth/login";
    };

    return (
        <>
            <Navbar
                color={props.location.pathname.indexOf("full-screen-maps") !== -1 ? "dark" : color}
                expand="lg"
                className={props.location.pathname.indexOf("full-screen-maps") !== -1 ? "navbar-absolute fixed-top" : "navbar-absolute fixed-top " + (color === "transparent" ? "navbar-transparent " : "")}
            >
                <Container fluid>
                    <div className="navbar-wrapper">
                        <div className="navbar-toggle">
                            <button type="button" ref={sidebarToggle} className="navbar-toggler" onClick={() => openSidebar()}>
                                <span className="navbar-toggler-bar bar1" />
                                <span className="navbar-toggler-bar bar2" />
                                <span className="navbar-toggler-bar bar3" />
                            </button>
                        </div>
                        <NavbarBrand>{getBrand()}</NavbarBrand>
                    </div>

                    <NavbarToggler onClick={toggle}>
                        <span className="navbar-toggler-bar navbar-kebab" />
                        <span className="navbar-toggler-bar navbar-kebab" />
                        <span className="navbar-toggler-bar navbar-kebab" />
                    </NavbarToggler>
                    <Collapse isOpen={isOpen} navbar className="justify-content-end align-items-center">

                        <div className="form-check form-switch mb-0">
                            <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={toggleServer} onChange={(e) => runServerMode(e)} style={{ cursor: "pointer" }} />
                            <p className="form-check-label" htmlFor="flexSwitchCheckDefault">Maintenance mode</p>
                        </div>

                        <Nav navbar>
                            <NavItem>
                                <Link to="/auth/logout" className="nav-link btn-magnify" onClick={handleOpen}>
                                    <i className="nc-icon nc-key-25" /> Logout
                                </Link>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>
            <Modal isOpen={maintainModal} toggle={toggleConfirm} centered={true} backdrop="static">
                <ModalHeader className="custom_header_colour align-items-center" toggle={toggleConfirm}>
                    <h3 className='mb-0' style={{ fontSize: '20px' }}>Server Alert</h3>
                </ModalHeader>
                <ModalBody>
                    <p className="card-just-text" style={{ fontSize: "20px" }}>
                        The Server is on Maintenance
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={handleMaintainModalOff}>Cancel</Button>
                </ModalFooter>
            </Modal>
            <Modal
                isOpen={show}
                toggle={handleClose}
                backdrop="static"
                keyboard={false}
                size="md"
                centered
            ><ModalBody>
			<div className="text-center">
				<img
					className="modal-img mb-4"
					src="/assets/images/exclamation.svg"
					alt=""
					style={{ maxWidth: '100px' }}
				/>
				<h4 className="modal-text mb-4">Are you sure you want to log out?</h4>
				<div className="d-flex justify-content-center">
					<div className="mx-2">
						<Button
							className="btn btn-danger"
							style={{ minWidth: "120px",backgroundColor:"#dc3545" }}
							onClick={logout}
						>
							<b>Yes, Logout</b>
						</Button>
					</div>
					<div className="mx-2">
						<Button
							className="btn" style={{backgroundColor:"#64bd90"}}
							onClick={handleClose}
						>
							<b>Cancel</b>
						</Button>
					</div>
				</div>
			</div>
		</ModalBody>
		
            </Modal>
        </>
    );
}

export default Header;
